import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY_TOKEN = "jw_customer_token";

const CustomerContext = createContext(null);

export function customerAuthHeaders() {
    const t = localStorage.getItem(KEY_TOKEN);
    return t ? { Authorization: `Bearer ${t}` } : {};
}

export function CustomerProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem(KEY_TOKEN));
    const [customer, setCustomer] = useState(null);

    const logout = useCallback(() => {
        localStorage.removeItem(KEY_TOKEN);
        setToken(null);
        setCustomer(null);
    }, []);

    const login = useCallback(async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        localStorage.setItem(KEY_TOKEN, r.data.token);
        setToken(r.data.token);
        setCustomer(r.data.customer);
        return r.data.customer;
    }, []);

    const register = useCallback(async (data) => {
        const r = await api.post("/auth/register", data);
        localStorage.setItem(KEY_TOKEN, r.data.token);
        setToken(r.data.token);
        setCustomer(r.data.customer);
        return r.data.customer;
    }, []);

    const updateProfile = useCallback(async (data) => {
        const r = await api.put("/auth/me", data, { headers: customerAuthHeaders() });
        setCustomer(r.data.customer);
        return r.data.customer;
    }, []);

    const fetchOrders = useCallback(async () => {
        const r = await api.get("/auth/my-orders", { headers: customerAuthHeaders() });
        return r.data.orders || [];
    }, []);

    // Validate token on mount
    useEffect(() => {
        if (!token) return;
        api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setCustomer(r.data.customer))
            .catch(() => logout());
    }, [token, logout]);

    return (
        <CustomerContext.Provider value={{ token, customer, login, register, logout, updateProfile, fetchOrders }}>
            {children}
        </CustomerContext.Provider>
    );
}

export function useCustomer() {
    const ctx = useContext(CustomerContext);
    if (!ctx) throw new Error("useCustomer must be used inside CustomerProvider");
    return ctx;
}
